import React from 'react';

import CategoriesDropdown from './CategoriesDropdown';

class DefaultDropdown extends React.PureComponent {
  render() {
    return (
      <CategoriesDropdown
        initialData={{ items: [] }}
        value={null}
        onChange={() => {}}
      />
    );
  }
}

export default DefaultDropdown;
